module.exports = __webpack_public_path__ + "img/Image - Header 5(1).f9d594af.png";